

const assert = {

    /**
     * <pre>
     * StringUtils.isBlank(null)      = true
     * StringUtils.isBlank("")        = true
     * StringUtils.isBlank(" ")       = true
     * StringUtils.isBlank("bob")     = false
     * StringUtils.isBlank("  bob  ") = false
     * </pre>
     * 
    */
    notBlank : (obj,msg)=>{
        let blank = obj===undefined||obj===null || 
        (typeof obj ==='string' && obj.trim().length == 0);

        assert.status(!blank,msg||'obj内容为空');
    },


    status : (explan,msg,callback)=>{
        if(!explan){
             //TODO callback怎么异常执行
             callback && callback();
            if(msg){
                throw msg;
            }else{
                throw "没有指导错误";
            }
        }
    },
    

};

export default assert;


// WEBPACK FOOTER //
// ./src/utils/assert.js